import Modal from '../../../../components/modal/modal';
import '../../../../components/modal/modal.scss';

export const ImportSummaryDialog = ({
    show,
    onHide,
    summary
}) => {
    return (
        <Modal
            open={show}
            onClose={onHide}
            fullWidth={true}
            maxWidth='md'
            modalHeading="Import Summary"
            modalCloseTxt='Close'
            showActionBtn
            cxlbtnClass='createBtn'
            primary
        >
            <div className="mb-4">
                <div className="ms-3">
                    <table className="table table-borderless summary-table mb-4">
                        <tbody>
                            <tr>
                                <td>General Items updated:</td>
                                <td className="text-end">{summary?.updatedItems?.length || 0}</td>
                            </tr>
                            <tr>
                                <td>New items added:</td>
                                <td className="text-end">{summary?.newItems?.length || 0}</td>
                            </tr>
                            <tr>
                                <td>Item templates updated:</td>
                                <td className="text-end">{summary?.updatedTemplates?.length || 0}</td>
                            </tr>
                            <tr>
                                <td>Task templates updated:</td>
                                <td className="text-end">{summary?.updatedTaskTemplates?.length || 0}</td>
                            </tr>
                            <tr>
                                <td>Projects updated:</td>
                                <td className="text-end">{summary?.updatedProjects?.length || 0}</td>
                            </tr>
                        </tbody>
                    </table>

                    {/* Projects Section */}
                    {(summary?.updatedProjects?.length > 0 || 
                      summary?.warnings?.filter(w => w.type === 'NO_CHANGES').length > 0 || 
                      summary?.skippedProjects?.length > 0) && (
                        <div className="row mt-4">
                            <div className="col-12 col-md-6 mb-3">
                                <h6 className="text-success small fw-bold mb-2">Projects Updated (New Revisions Created):</h6>
                                <div style={{ maxHeight: '180px', overflowY: 'auto' }} className="border rounded p-2 bg-light">
                                    {summary?.updatedProjects?.length > 0 ? (
                                        <ul className="list-unstyled ms-2 small mb-0">
                                            {summary.updatedProjects.map((p, i) => (
                                                <li key={i} className="mb-1 text-truncate" title={p.name}>✅ {p.name}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <span className="text-muted small ms-2">No projects updated</span>
                                    )}
                                </div>
                            </div>

                            <div className="col-12 col-md-6 mb-3">
                                <h6 className="text-info small fw-bold mb-2">Projects Already Up-to-date (Skipped):</h6>
                                <div style={{ maxHeight: '180px', overflowY: 'auto' }} className="border rounded p-2 bg-light">
                                    {(summary?.warnings?.filter(w => w.type === 'NO_CHANGES').length > 0 || summary?.skippedProjects?.length > 0) ? (
                                        <ul className="list-unstyled ms-2 small mb-0">
                                            {summary.warnings?.filter(w => w.type === 'NO_CHANGES').map((w, i) => (
                                                <li key={i} className="mb-1 text-truncate" title={w.name}>ℹ️ {w.name}</li>
                                            ))}
                                            {summary.skippedProjects?.map((p, i) => (
                                                <li key={i} className="mb-1 text-truncate" title={p.name}>ℹ️ {p.name}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <span className="text-muted small ms-2">No projects skipped</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Item Templates Section */}
                    {(summary?.updatedTemplates?.length > 0 || summary?.skippedTemplates?.length > 0) && (
                        <div className="row mt-4">
                            <div className="col-12 col-md-6 mb-3">
                                <h6 className="text-success small fw-bold mb-2">Item Templates Updated:</h6>
                                <div style={{ maxHeight: '180px', overflowY: 'auto' }} className="border rounded p-2 bg-light">
                                    {summary?.updatedTemplates?.length > 0 ? (
                                        <ul className="list-unstyled ms-2 small mb-0">
                                            {summary.updatedTemplates.map((t, i) => (
                                                <li key={i} className="mb-1 text-truncate" title={t.name}>✅ {t.name}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <span className="text-muted small ms-2">No item templates updated</span>
                                    )}
                                </div>
                            </div>

                            <div className="col-12 col-md-6 mb-3">
                                <h6 className="text-info small fw-bold mb-2">Item Templates Already Up-to-date (Skipped):</h6>
                                <div style={{ maxHeight: '180px', overflowY: 'auto' }} className="border rounded p-2 bg-light">
                                    {summary?.skippedTemplates?.length > 0 ? (
                                        <ul className="list-unstyled ms-2 small mb-0">
                                            {summary.skippedTemplates.map((t, i) => (
                                                <li key={i} className="mb-1 text-truncate" title={t.name}>ℹ️ {t.name}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <span className="text-muted small ms-2">No item templates skipped</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Task Templates Section */}
                    {(summary?.updatedTaskTemplates?.length > 0 || summary?.skippedTaskTemplates?.length > 0) && (
                        <div className="row mt-4">
                            <div className="col-12 col-md-6 mb-3">
                                <h6 className="text-success small fw-bold mb-2">Task Templates Updated:</h6>
                                <div style={{ maxHeight: '180px', overflowY: 'auto' }} className="border rounded p-2 bg-light">
                                    {summary?.updatedTaskTemplates?.length > 0 ? (
                                        <ul className="list-unstyled ms-2 small mb-0">
                                            {summary.updatedTaskTemplates.map((t, i) => (
                                                <li key={i} className="mb-1 text-truncate" title={t.name}>✅ {t.name}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <span className="text-muted small ms-2">No task templates updated</span>
                                    )}
                                </div>
                            </div>

                            <div className="col-12 col-md-6 mb-3">
                                <h6 className="text-info small fw-bold mb-2">Task Templates Already Up-to-date (Skipped):</h6>
                                <div style={{ maxHeight: '180px', overflowY: 'auto' }} className="border rounded p-2 bg-light">
                                    {summary?.skippedTaskTemplates?.length > 0 ? (
                                        <ul className="list-unstyled ms-2 small mb-0">
                                            {summary.skippedTaskTemplates.map((t, i) => (
                                                <li key={i} className="mb-1 text-truncate" title={t.name}>ℹ️ {t.name}</li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <span className="text-muted small ms-2">No task templates skipped</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

        </Modal>
    );
};
